import useTiclickTableConfig from '@shared/hooks/use-ticlick-table-config';
import { TABLES_KEYS } from '@shared/constants/tables-keys';
import reminderApi from '@src/features/reminders/services/reminder-api';
import {
  REMINDER_ENTITY_STATUSES,
  TReminder,
} from '@src/shared/types/reminder';

import { bulkRemindersColumns } from './bulk-reminders-columns';
import { UpcomingReminderCancelButton } from '../../reminders-dashboard/upcoming-reminders/upcoming-reminder-row-buttons';
import { BULK_REMINDER_TYPES } from '../reminder-type-filters';
import { BulkReminderLogsDialogButton } from '../bulk-reminder-logs/bulk-reminder-logs-dialog-button';
import { ActionItemProps } from '@src/design-system/molecules/ticlick-table/ticlick-table-table-actions';
import {
  CreateReminderTriggerButton,
  DuplicateBulkReminderButton,
} from '../../create-reminder';
import { useHasPermission } from '@src/shared/hooks/use-has-permission';
import { entities } from '@src/shared/constants/entities';

export function useBulkRemindersTable() {
  const hasPermission = useHasPermission();
  const actionsTable: ActionItemProps<TReminder>[] = [
    {
      key: 'add',
      visibility: 'none-selection',
      minWidth: 77,
      render: () => <CreateReminderTriggerButton />,
      isDisplay: hasPermission(entities.reminder, 'add'),
    },
  ];
  const table = useTiclickTableConfig({
    fetchingData: {
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      fetchFn: reminderApi.useFetch,
      query: {
        type: BULK_REMINDER_TYPES,
        o: ['-date'],
      },
    },
    options: {
      columns: bulkRemindersColumns,
    },
    identifyingData: { tableKey: TABLES_KEYS.bulkRemindersTable },
    rowActions: [
      {
        key: 'cancel',
        render: (row) =>
          row.original.status === REMINDER_ENTITY_STATUSES.scheduled ? (
            <UpcomingReminderCancelButton row={row} />
          ) : (
            <DuplicateBulkReminderButton reminder={row.original} />
          ),
        minWidth: 36,
      },
      {
        key: 'view',
        render: (row) => <BulkReminderLogsDialogButton row={row} />,
        minWidth: 36,
      },
    ],
  });

  return { table, actionsTable };
}
